async function signAndExecuteTransaction(wallet, input) {
  if (!wallet.features["iota:signAndExecuteTransaction"]) {
    throw new Error(
      `Provided wallet (${wallet.name}) does not support the signAndExecuteTransaction feature.`
    );
  }
  return wallet.features["iota:signAndExecuteTransaction"].signAndExecuteTransaction(input);
}
async function signTransaction(wallet, input) {
  if (!wallet.features["iota:signTransaction"]) {
    throw new Error(
      `Provided wallet (${wallet.name}) does not support the signTransaction feature.`
    );
  }
  return wallet.features["iota:signTransaction"].signTransaction(input);
}
export {
  signAndExecuteTransaction,
  signTransaction
};
//# sourceMappingURL=wallet.js.map
